import { useContext } from 'react'
import { StateContext, IStateContext } from '../providers/StateProvider'

export default function useState(): IStateContext {
  return useContext(StateContext)
}
